const formatMoney = (value, decimals = 0, prefix = '$') => {
  value = parseFloat(value);
  decimals = parseInt(decimals);

  if (isNaN(value) || isNaN(decimals)) {
    return value;
  }

  const decimal = decimals !== 0
    ? `.${ value.toFixed(decimals).slice(-decimals) }`
    : '';

  value = Math.floor(value);

  return (`${prefix}${ value },`)
    .replace(/(\d)(?=(\d{3})+\,)/g, '$1,')
    .slice(0, -1) + decimal;
};

const formatPercent = (value, decimals = 0, prefix = '%') => {
  value = parseFloat(value);
  decimals = parseInt(decimals);

  if (isNaN(value) || isNaN(decimals)) {
    return value;
  }

  const decimal = decimals !== 0
    ? `.${value.toFixed(decimals).slice(-decimals)}`
    : '';

  return (`${ Math.trunc(value) },`)
    .replace(/(\d)(?=(\d{3})+\.)/g, '$1.')
    .slice(0, -1) + decimal + prefix;
}

export { formatMoney, formatPercent }